import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    projects: [],
    searchText: ''
}

const filterSlice = createSlice({
    name: "filter",
    initialState,
    reducers: {
        setProjects: (state, action) => {
            state.projects = action.payload
        },
        changeShow: (state, action) => {
            state.projects.forEach(single => {
                if (single.projectName === action.payload.projectName) {
                    single.show = action.payload.show
                }
            });

        },
        setSearchText: (state, action) => {
            state.searchText = action.payload;
        }
    },
});
export const { setSearchText, setProjects, changeShow } = filterSlice.actions;
export default filterSlice.reducer;